import loadable from '@loadable/component';

import type { CmsApiBlockquoteBlockData } from '#/modules/cms/api/types/blocks/CmsApiBlockquoteBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsBlockquoteBlockMapping: CmsBlockMapping<CmsApiBlockquoteBlockData> =
  {
    invariant: [
      {
        prop: 'quote',
        msg: 'Quote required for blockquote',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: loadable(() => import('./CmsBlockquoteBlock'), {
      resolveComponent: (module) => module.CmsBlockquoteBlock,
    }),
  };
